import { Row, Col } from 'antd'
import _ from 'lodash'
import { InputCountField, HyperLink } from '../../../../Common/Form'
import { Field, FormValueSelector } from '../../../../Common/forms'
import ListingLink from '../../../../Common/ListingLink/ListingLink'
import Tip from '../../../Common/Tip'
import SingleLineText from '../../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { IconPopoverLabel } from '../../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import styles from './index.css'

const ListingNameSection = props => {
  const {
    readOnly,
    onListingNameChange,
    supplier
  } = props
  // 因為已綁定修改賣場資訊的 redux form 表單 ListingLink 拿不到賣場連結
  // 改成直接從外面傳入設定的賣場連結
  const buyGdSaleUrl = _.get(supplier, 'sharedLink.buyGdSale')
  return (
    <>
      <Row
        type='flex'
        align='middle'
        justify='space-between'
        className={styles.panelHeader}
      >
        <Col span={4}>
          <p>賣場編號</p>
          <FormValueSelector
            selector={select => ({
              listingId: select('id')
            })}
          >
            {({ listingId }) => {
              return (
                <ListingLink
                  className={styles.listingId}
                  targetListingId={listingId}
                  buyGdSaleUrl={buyGdSaleUrl}
                >
                  {listingId}
                </ListingLink>
              )
            }}
          </FormValueSelector>
        </Col>
        <Col span={20}>
          <IconPopoverLabel
            align='top'
            popoverContent={(
              <>
                商品名稱 = 賣場名稱-第1層項目-第2層項目
                <br />
                內容順序建議：品牌、商品名、型號、關鍵規格、組合數量(非必要)、促銷字 (非必要，如福利品/限定款)。
                <br />
                請妥善運用前28個字，可增加SEO流量，細節請參考
                <HyperLink
                  target='_blank'
                  href='https://docs.google.com/presentation/d/1EMDnUOHTjurkR5CoYnt0B_qgsRWvQobKAYHjgoUzKsk/edit#slide=id.gc6f9544c1_0_0'
                >
                  SEO優化詳細說明
                </HyperLink>
                。
              </>
            )}
          >
            賣場名稱
            <Tip
              tag='span'
              type='info'
            >
              {' '}
              (若調整將自動連動商品名稱修改)
            </Tip>
          </IconPopoverLabel>
          <Field
            name='name'
            component={readOnly ? SingleLineText : InputCountField}
            className={styles.listingName}
            countLimit={100}
            // 賣場名稱連動商品名稱 event
            onChange={onListingNameChange}
            fullWidth
            showErrorOnActive
            mustShowFormError
          />
        </Col>
      </Row>
    </>
  )
}

export default ListingNameSection
